import { useEffect } from 'react';
import { useQuery } from 'v3/hooks/useQuery';

import SuccessTemplate from 'templates/Success';
import WomanCelebrating from 'assets/images/woman-celabrating.png';

import * as S from './styles';

/**
 * Only a URL Stripe would have given us is worth rendering as a button.
 *
 * The link arrives in a query parameter, so anyone can craft one. Without this check the page
 * becomes a way to dress an arbitrary destination in our branding, on the screen where a
 * member is expecting to be asked for bank details.
 */
const isStripeHostedUrl = (candidate: string) => {
  try {
    const { protocol, hostname } = new URL(candidate);
    return protocol === 'https:' && (hostname === 'stripe.com' || hostname.endsWith('.stripe.com'));
  } catch {
    return false;
  }
};

const Microdeposits = () => {
  const query = useQuery();
  const name = query.get('name') ?? '';
  const verifyUrl = query.get('verifyUrl') ?? '';
  const stripeVerification = isStripeHostedUrl(verifyUrl) ? verifyUrl : '';

  useEffect(() => {
    if (!name) {
      window.location.href = 'https://contractflow.savings.club/deals/';
    }
  }, [name]);

  return (
    <SuccessTemplate firstName={name} img={WomanCelebrating}>
      <S.Container>
        {stripeVerification ? (
          <>
            <S.Text>
              <strong>We sent a small deposit to your bank.</strong> It arrives in{' '}
              <strong>1-2 business days</strong> with a 6-character code starting with SM. Enter
              that code to finish setting up your account.
            </S.Text>

            <S.VerifyLink href={stripeVerification}>Enter your code</S.VerifyLink>
          </>
        ) : (
          <S.Text>
            <strong>We have received your credentials</strong> Within <strong>3 days</strong> we
            will send you an email if everything went well.
          </S.Text>
        )}

        <S.Button
          type="button"
          onClick={() => {
            window.location.href = `?closeWebview=true&name=${name}`;
          }}
        >
          <S.CheckAppText>{'Check your app >'}</S.CheckAppText>
        </S.Button>
      </S.Container>
    </SuccessTemplate>
  );
};

export default Microdeposits;
